import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Grid } from '@ff-os/shared-react/components/grid/Grid';
import { WindowHeader } from '@ff-os/shared-react/components/window/partials/WindowHeader';
import { WindowContext } from '@ff-os/shared-react/context/window/WindowContext';
import { selectNonPinnedVariables } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { noop } from 'lodash';
import { useOrientation } from '../../context/Orientation';
import { usePreviewSize } from '../../context/PreviewSize';
import { Variables } from '../../variables/Variables';
import { GiftWindowStepProps } from '../shared/giftWindowSteps';
import { GiftWindowFooter } from '../shared/partials/GiftWindowFooter';

export const _NonPinnedVariablesWindow = ({
    variables,
    onClose, previous, next,
    previousButtonText, nextButtonText
}: Props) => {

    const { t } = useTranslation();
    usePreviewSize('small');
    useOrientation('screen');

    return (
        <WindowContext isOpen close={noop}>
            <WindowContext.Header>
                <WindowHeader previous={previous ?? onClose} onClose={onClose}>
                    {t('windows.non_pinned_variables.heading')}
                </WindowHeader>
            </WindowContext.Header>
            <WindowContext.Body>
                <Grid direction='column' gap='s'>
                    <Variables variables={variables} />
                </Grid>
            </WindowContext.Body>
            <WindowContext.Footer>
                <GiftWindowFooter
                    next={next} nextButtonText={nextButtonText}
                    previous={previous} previousButtonText={previousButtonText}
                    onClose={onClose} />
            </WindowContext.Footer>
        </WindowContext>
    );
};

type Props = GiftWindowStepProps & {
    variables: GiftJson.Variable<any>[];
};

const mapStateToProps = (state: GiftPdpState) => ({
    variables: selectNonPinnedVariables(state)
});

export const NonPinnedVariablesWindow = connect(
    mapStateToProps
)(_NonPinnedVariablesWindow);